var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:`ycmd-light-gray b b-1 br-2 pa-4 ${_vm.sectionClass}`,attrs:{"fluid":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_vm._t("section-content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }